import React from 'react'
import ContactForm from '../components/ContactForm'
import Navbar from '../components/Navbar'
import NewsLetter from '../components/NewsLetter'
import Footer from '../components/Footer'

export default function ContactUs() {
  return (
    <>
      <ContactForm/>
      <NewsLetter/>
      <Footer/>
    </>
  )
}
